export class KDSTerminalMessage {
    terminal_id: number;
    message: string;
    type: string;    
}
